import { ReactNode } from "react"
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, IconButton, Tooltip, makeStyles } from "@material-ui/core"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { ContentCard } from "@ksana/vira-ui"

import { colors } from "../../../utils/theme"

interface ChartContainerProps {
  /** Optional — omit so cards match Sleep / Activity (title only). */
  icon?: IconDefinition
  iconBgColor?: string
  title: string
  tooltipText?: string
  children?: ReactNode
  footer?: ReactNode
}

/**
 * Chart panel — canonical ContentCard (header / body / footer).
 */
export default function ChartCard({
  icon,
  iconBgColor = colors.tertiary.violet,
  title,
  tooltipText,
  children,
  footer,
}: ChartContainerProps) {
  const classes = useStyles()

  return (
    <ContentCard
      title={title}
      titleStart={
        icon ? (
          <div
            className={classes.iconContainer}
            style={{ backgroundColor: iconBgColor }}
          >
            <FontAwesomeIcon icon={icon} className={classes.icon} />
          </div>
        ) : undefined
      }
      actions={
        tooltipText ? (
          <Tooltip arrow title={tooltipText} placement="top">
            <IconButton
              className={classes.infoButton}
              size="small"
              aria-label={tooltipText}
            >
              <FontAwesomeIcon
                icon={faInfoCircle}
                size="1x"
                color={colors.neutral.denim}
              />
            </IconButton>
          </Tooltip>
        ) : undefined
      }
      footer={footer}
    >
      <Box className={classes.content}>{children}</Box>
    </ContentCard>
  )
}

const useStyles = makeStyles(() => ({
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    color: colors.neutral.white,
    flexShrink: 0,
  },
  icon: {
    fontSize: 14,
  },
  infoButton: {
    padding: 2,
    flexShrink: 0,
  },
  content: {
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
  },
}))
